import { useQuery } from "react-query";
import axios from "../axios";

const useGetSellerStatus = ({ seller_id }) => {
  const query = useQuery(
    ["status", seller_id],
    async () => {
      const response = await axios.get(
        `/api/v2/product/stats/seller?id=${seller_id}`
      );
      return response.data;
    },
    {
      enabled: !!seller_id, // only fetch when seller_id exists
    }
  );

  return query;
};

export default useGetSellerStatus;
